export default {
  chatSearchQuery: "",
  contacts: [],
  chatContacts: [],
  chats: {},
}
